import React, { useState } from "react";
import { Grid, Typography, Button } from "@mui/material";
import DropDownList from "../../UX/DropDownList/DropDownList";
import SelfClearingNumericTextBox from "../../UX/DataGridCells/SelfClearingNumericTextBox/SelfClearingNumericTextBox";
import "./TaxFilingStatusUponDeath.scss";

const TaxFilingStatusUponDeath = (props) => {
  const taxFilingStatusOptions = [
    {
      value: "SINGLE",
      text: "Single",
    },
    {
      value: "HEAD_OF_HOUSEHOLD",
      text: "Head of Household",
    },
  ];

  const taxDeductionOptions = [
    {
      value: "ITEMIZED",
      text: "Itemized",
    },
    {
      value: "STANDARD",
      text: "Standard",
    },
  ];

  return (
    <Grid
      className={"tax-filing-status-before-death-page"}
      container
      spacing={3}
    >
      <Grid item xs={12}>
        <Typography component={"h1"} variant={"h1"}>
          Tax Filing Changes Upon Death
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography component={"p"} variant={"p"}>
          Plan Wizard has evaluated there is a need to change Tax Filing status due to death of spouse in {props.deathYear}.
        </Typography>
      </Grid>
      {props.showValidationMessage && <Grid className={"validation-message"} item xs={12}>
        <Typography component={"p"} variant={"p"}>
          Itemized Deduction must be greater than Standard Deduction for Tax Filing Status. Please increase the amount or select Standard Deduction for Tax Deduction Type.
        </Typography>
      </Grid>}
      <Grid item xs={6}>
        <Typography className={"tax-filing-status-label"} component={"p"} variant={"p"}>
          Select the Tax Filing Status that will start on January of {props.deathYear + 1}.
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <DropDownList
          data={taxFilingStatusOptions}
          textField={"text"}
          dataItemKey={"value"}
          value={taxFilingStatusOptions.find(item => item.value === props.state.taxFillingStatusType)}
          onChange={(event) => {
            props.setState({
              ...props.state,
              taxFillingStatusType: event.value.value,
            });
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Typography className={"tax-filing-status-label"} component={"p"} variant={"p"}>
          Select the Tax Deduction Type that will start on {props.deathYear + 1}.
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <DropDownList
          data={taxDeductionOptions}
          value={taxDeductionOptions.find(item => item.value === props.state.deductionType)}
          textField={"text"}
          dataItemKey={"value"}
          onChange={(event) => {
            props.setState({
              ...props.state,
              deductionType: event.value.value,
            });
          }}
        />
      </Grid>
      {props.state.deductionType === "ITEMIZED" && (
        <React.Fragment>
          <Grid item xs={6}>
            <Typography component={"label"} variant={"label"}>Itemized deduction estimated amount</Typography>
          </Grid>
          <Grid item xs={6} className={"itemized-deduction-textbox"}>
            <SelfClearingNumericTextBox
              update={(event) => {
                props.setState({
                  ...props.state,
                  itemizedDeduction: event.target.value,
                });
              }}
              value={props.state.itemizedDeduction}
              format={"c2"}
            />
          </Grid>
        </React.Fragment>
      )}

    </Grid>
  );
};

export default TaxFilingStatusUponDeath;
